import { getFunctions, httpsCallable } from 'firebase/functions';

export async function unpublishTour(tourId: string): Promise<void> {
  const functions = getFunctions();
  const unpublishTour = httpsCallable(functions, 'payment-unpublishTour');
  try {
    const params = {
      tourId,
    };
    const response = await unpublishTour(params);
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  } catch (err) {
    console.error(JSON.stringify(err));
    throw err;
  }
}
